<template>
  <v-main class="d-flex" height="100%">
    <div class="iconHamburger" v-show="tap" @click="menubar()">
      <v-icon>menu</v-icon>
    </div>
    <v-navigation-drawer id="menu"  permanent left>
      <div id="title" class="d-flex justify-sm-space-between">
        <h1>Apunn</h1>
        <v-spacer></v-spacer>
        <v-icon id="close" @click="closemenubar()">close</v-icon>
      </div>
      <div class="menubar d-flex flex-column" id="textmenu">
        <div v-for="(item, index) in items" :key="index" >
          <v-icon id="icon" outlined>{{ item.icon }}</v-icon>
          <a :href="links[index]" v-smooth-scroll style="color:red">{{
            item.title
          }}</a>
        </div>
      </div>
    </v-navigation-drawer>
  </v-main>
</template>

<script>
export default {
  name: "navbar",
  data: () => {
    return {
      tap: true,
      links: [
        "#Home",
        "#About",
        "#Service",
        "#Experience",
        "#Works",
        "#Contact",
      ],
      items: [
        { icon: "home", title: "Home" },
        { icon: "how_to_reg", title: "About" },
        { icon: "work", title: "Hobbie" },
        { icon: "school", title: "Experience" },
        { icon: "desktop_windows", title: "Work" },
        { icon: "textsms", title: "Contact" },
      ],
    };
  },
  methods: {
    menubar() {
      this.tap = !this.tap;
      console.log("menu", this.tap);
      document.getElementById("menu").style.display = "inherit";
      document.getElementById("title").style.opacity = "1";
      document.getElementById("textmenu").style.display = "inherit";
    },
    closemenubar() {
      this.tap = !this.tap;
      console.log("menu", this.tap);
      document.getElementById("menu").style.display = "none";
      // document.getElementById("title").style.opacity = "1";
      // document.getElementById("textmenu").style.display = "inherit";
    },
  },
};
</script>

<style>
#close {
  display: none;
}
#title {
  padding: 2em;
  color: #48445e;
  font-size: 25px !important;
  font-family: "Poppins", sans-serif;
}
.iconHamburger {
  display: none;
}
#menu {
  background-color: #faf8ff;
  z-index: 150  !important;
  width: 300px !important;
}
.menubar {
  padding: 2em;
  height: 100vh;
  margin-top: 5em;
}
.menubar div {
  padding: 0.6em;
}
.menubar a {
  padding: 1em;
  text-decoration: none;
  font-weight: 600;
  color: #48445e !important;
}
#icon {
  color: #fd3557 !important;
}
.menubar a:hover {
  color: #fd3557 !important;
}
@media only screen and (max-width: 1300px) {
  @keyframes slider {
    0%{
      transform: translateX(-250px);
    }
    100%{
      transform: translateX(10px);
    }
  }
  #menu {
    width: 250px !important;
    height: 100%;
    background-color: #faf8ff;
    display: none;
    box-shadow: 5px 5px 5px rgba(128, 128, 128, 0.178);
    animation: slider 0.5s ease-in ;
    z-index: 20  !important;
  }
  
  #close {
    display: inherit;
  }
  .menubar a {
    display: inherit;
  }
  .menubar {
    height: 100vh;
  }
  .menubar div {
  padding: 0;
  display: flex;
}
  #title {
    /* padding: 20px; */
    opacity: 1;
    font-size: 15px !important;
  }
  .iconHamburger {
    padding: 30px 20px 0 20px;
    display: inherit;
    z-index: 2;
  }
}
@media only screen and (max-width: 600px) {
  #title {
    padding: 20px;
    opacity: 1;
    font-size: 15px !important;
  }
}
</style>
